export default function link(track, trackSlugsData) {
  return {
    ...track,
    link: trackSlugsData['0'].slugNewValue
  }
}